import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TesterModal from "../Tester/tester";

const NavbarWithModal = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand">Hospital Portal</div>
        <div className="navbar-links">
          <a href="/" className="navbar-link">Home</a>
          <button
            className="navbar-link btn btn-link text-decoration-none p-0"
            onClick={() => setShowModal(true)}
          >
            Book Appointment
          </button>
        </div>
      </nav>
      <TesterModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
};

const LoginPage = ({ setUserId }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.post("https://ricgop.online/api/login.php", {
        email,
        password,
      });

      if (res.data.success) {
        if (setUserId) setUserId(res.data.userId);
        navigate("/patient/dashboard");
      } else {
        setError("Invalid email or password");
      }
    } catch (err) {
      setError("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <NavbarWithModal />
      <div className="login-container" aria-label="Hospital-themed login page">
        <div className="login-card" role="form" aria-labelledby="login-title">
          <div className="logo-container" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" className="logo-icon" viewBox="0 0 64 64" fill="none">
              <rect x="26" y="6" width="12" height="52" rx="2" fill="#3f51b5" />
              <rect x="6" y="26" width="52" height="12" rx="2" fill="#3f51b5" />
            </svg>
          </div>
          <h1 id="login-title" className="login-title">Patient Login</h1>

          {error && <p className="message error" role="alert">{error}</p>}

          <label htmlFor="email" className="input-label">
            Email
            <input
              id="email"
              type="email"
              placeholder="you@example.com"
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </label>

          <label htmlFor="password" className="input-label">
            Password
            <input
              id="password"
              type="password"
              placeholder="••••••••"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          <button
            onClick={handleLogin}
            disabled={loading}
            className={`login-btn ${loading ? "loading" : ""}`}
            aria-busy={loading}
          >
            {loading ? <span className="spinner" aria-label="Loading"></span> : "Login"}
          </button>

          <p className="login-footer">
            Want to book appointment?{" "}
            <a href="/patient/booking" className="login-link">
              Register here
            </a>
          </p>
        </div>
      </div>

      <style>{`
        .spinner {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid #fff;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
                  .navbar {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          background: #3f51b5;
          color: white;
          padding: 15px 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 100;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }
        .navbar-brand {
          font-size: 1.4rem;
          font-weight: bold;
          letter-spacing: 1px;
        }
        .navbar-links {
          display: flex;
          gap: 25px;
        }
        .navbar-link {
          color: white;
          font-weight: 500;
          font-size: 1.05rem;
          text-decoration: none;
          transition: opacity 0.3s ease;
        }
        .navbar-link:hover {
          opacity: 0.8;
        }
        .login-container {
          padding-top: 100px; /* Push down due to fixed navbar */
        }
           @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');

        /* Container & Background */
        .login-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          background: linear-gradient(135deg, #74ebd5 0%, #ACB6E5 100%);
          position: relative;
          font-family: 'Poppins', sans-serif;
          overflow: hidden;
          animation: fadeInBg 1.5s ease forwards;
        }
        @keyframes fadeInBg {
          from {opacity: 0;}
          to {opacity: 1;}
        }

        /* Subtle animated circles */
        .login-container::before, .login-container::after {
          content: "";
          position: absolute;
          border-radius: 50%;
          opacity: 0.15;
          animation: floatUpDown 8s ease-in-out infinite;
          z-index: 0;
        }
        .login-container::before {
          width: 450px;
          height: 450px;
          background: #3f51b5;
          top: -150px;
          left: -150px;
          animation-delay: 0s;
          filter: blur(80px);
        }
        .login-container::after {
          width: 350px;
          height: 350px;
          background: #82caff;
          bottom: -120px;
          right: -130px;
          animation-delay: 4s;
          filter: blur(70px);
        }
        @keyframes floatUpDown {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(15px); }
        }

        /* Card */
        .login-card {
          position: relative;
          background: #ffffffee;
          padding: 50px 45px 60px;
          border-radius: 28px;
          box-shadow:
            0 16px 40px rgba(0, 0, 0, 0.12),
            inset 0 0 60px rgba(255, 255, 255, 0.85);
          max-width: 420px;
          width: 100%;
          z-index: 1;
          backdrop-filter: saturate(180%) blur(20px);
          transition: box-shadow 0.4s ease;
          text-align: center;
          animation: fadeInUp 1s ease forwards;
        }
        .login-card:hover {
          box-shadow:
            0 20px 60px rgba(0, 0, 0, 0.18),
            inset 0 0 80px rgba(255, 255, 255, 0.9);
        }
        @keyframes fadeInUp {
          from {opacity: 0; transform: translateY(20px);}
          to {opacity: 1; transform: translateY(0);}
        }

        /* Hospital cross logo */
        .logo-container {
          margin-bottom: 24px;
          display: flex;
          justify-content: center;
        }
        .logo-icon {
          width: 70px;
          height: 70px;
          filter: drop-shadow(0 0 4px #3f51b5aa);
          transition: transform 0.4s ease;
        }
        .login-card:hover .logo-icon {
          transform: rotate(10deg);
        }

        /* Title */
        .login-title {
          font-weight: 700;
          font-size: 2.5rem;
          margin-bottom: 36px;
          color: #283593;
          letter-spacing: 1.5px;
          text-shadow: 0 1px 4px rgba(0,0,0,0.07);
          user-select: none;
        }

        /* Error message */
        .message.error {
          background-color: #ffebee;
          color: #c62828;
          border: 1px solid #e53935;
          padding: 14px 20px;
          margin-bottom: 28px;
          border-radius: 16px;
          font-weight: 600;
          user-select: none;
          box-shadow: 0 6px 15px rgba(255, 0, 0, 0.12);
          transition: background-color 0.3s ease;
        }
        .message.error:hover {
          background-color: #ffcdd2;
        }

        /* Inputs */
        .input-label {
          display: block;
          font-weight: 600;
          color: #3949ab;
          margin-bottom: 20px;
          font-size: 1.15rem;
          text-align: left;
          user-select: none;
        }
        .input-field {
          width: 100%;
          padding: 16px 22px;
          margin-top: 8px;
          font-size: 1.1rem;
          border-radius: 18px;
          border: 2.5px solid #9fa8da;
          outline-offset: 4px;
          transition: border-color 0.3s ease, box-shadow 0.4s ease;
          font-family: inherit;
          color: #1a237e;
          background-color: #e8eaf6;
          box-shadow:
            inset 2px 2px 8px #c5cae9,
            inset -2px -2px 8px #f9f9ff;
          user-select: text;
        }
        .input-field::placeholder {
          color: #7986cb;
          font-style: italic;
        }
        .input-field:focus {
          border-color: #3949ab;
          box-shadow: 0 0 15px #3949abcc;
          background-color: #fff;
        }

        /* Button */
        .login-btn {
          width: 100%;
          padding: 18px 0;
          border: none;
          border-radius: 24px;
          background: linear-gradient(135deg, #283593, #5c6bc0);
          color: white;
          font-weight: 700;
          font-size: 1.25rem;
          cursor: pointer;
          box-shadow:
            0 12px 25px rgba(40, 53, 147, 0.7),
            0 0 18px #5c6bc0;
          transition: background 0.5s ease, box-shadow 0.4s ease, transform 0.15s ease;
          user-select: none;
          letter-spacing: 0.05em;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;
          position: relative;
          overflow: hidden;
        }
        .login-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, #5c6bc0, #283593);
          box-shadow:
            0 14px 35px rgba(40, 53, 147, 0.9),
            0 0 25px #3949ab;
          transform: translateY(-3px);
        }
        .login-btn:disabled {
          background: #9fa8da;
          cursor: not-allowed;
          box-shadow: none;
          transform: none;
        }

        /* Loading spinner */
        .spinner {
          border: 3px solid transparent;
          border-top: 3px solid white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          animation: spin 1s linear infinite;
          display: inline-block;
        }
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }

        /* Footer */
        .login-footer {
          margin-top: 26px;
          font-weight: 500;
          font-size: 1rem;
          color: #3f51b5dd;
          user-select: none;
        }
        .login-link {
          color: #283593;
          font-weight: 700;
          text-decoration: none;
          transition: color 0.3s ease;
        }
        .login-link:hover,
        .login-link:focus {
          color: #1a237e;
          text-decoration: underline;
          outline: none;
        }

        /* Responsive */
        @media (max-width: 480px) {
          .login-card {
            padding: 40px 30px 50px;
            border-radius: 24px;
          }
          .login-title {
            font-size: 2rem;
          }
          .input-label {
            font-size: 1rem;
          }
          .login-btn {
            font-size: 1.1rem;
            padding: 14px 0;
          }
        }
      `}</style>
    </>
  );
};

export default LoginPage;
